import GuestInfoInput from './GuestInfoInput';

export default GuestInfoInput;
